
<section class="container-fluid sts-section sts-form">

  <app-sts-section-header *ngIf="isEmail" key="sts-signup-step-3-validate-header" [errors]="errors">
    Validate Your Email
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-header *ngIf="!isEmail" key="sts-signup-step-3-validate-header-phone" [errors]="errors">
    Validate Your Phone
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <div class="sts-body row sts-signin-text" *ngIf="isEmail && !wantsToChangeEmail">
    <div class="col-24">
      <div>
        {{sentEmailMessage}}
      </div>
    </div>
  </div>
  <div class="sts-body row sts-signin-text" *ngIf="!isEmail && !wantsToChangeEmail">
    <div class="col-24">
      <div>
        {{sentPhoneTextMessage}}
      </div>
    </div>
  </div>

  <form #form="ngForm"
        *ngIf="!wantsToChangeEmail"
        (ngSubmit)="onSubmitCode()"
        [formGroup]="frm2"
        class="sts-form" autocomplete="off">

    <div class="row sts-form-row sts-form-last-row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">

          <div>
            <div class="sts-label-row">
              <label app-sts-cms-txt key="sts-pick-verification-code" for="sts_verification_code">
                Verification Code:
              </label>
            </div>
            <div class="sts-input-row">
              <input type="text"
                    id="sts_verification_code"
                    name="sts_verification_code"
                    formControlName="code"
                    maxlength="100"
                    [ngClass]="{'has-errors' : isInvalidCode() }"
                    class="sts-textbox" >
              <div *ngIf="isEmail">
                <a href="javascript:void(0)" (click)="resendEmail()" app-sts-cms-txt key="sts-resend-email-2fa-cta">(resend email)</a>
                <a *ngIf="!isEmailReadOnly" href="javascript:void(0)" (click)="changeMode()" app-sts-cms-txt key="sts-change-email-2fa-cta">(change your email)</a>
              </div>
              <div *ngIf="!isEmail">
                <a href="javascript:void(0)" (click)="resendEmail()" app-sts-cms-txt key="sts-resend-email-2fa-cta-phone">(resend SMS)</a>
              </div>
              <div class="text-danger" *ngIf="frm2.controls['code'].invalid && (frm2.controls['code'].dirty || frm2.controls['code'].touched)">
                <div app-sts-cms-txt key="sts-otc-is-valid-required" *ngIf="frm2.controls['code'].errors['required']">A valid code is required</div>
              </div>
            </div>
          </div>


        </div>
        <!-- -->


      </div>
    </div>

    <div class="row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">
          <button app-sts-cms-txt key="sts-cancel-button"
                  class="sts-btn other-sts-btn"
                  type="button"
                  (click)="gotoHome()">
            Cancel
          </button>
          <app-sts-button [submit]="submitter"
                          key="sts-next-button">
            Next
          </app-sts-button>
        </div>
        <!-- -->

      </div>
    </div>

  </form>

  <form #form="ngForm"
        *ngIf="wantsToChangeEmail"
        (ngSubmit)="onSubmit()"
        [formGroup]="frm"
        class="sts-form" autocomplete="off">

    <div class="row sts-form-row sts-form-last-row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">

          <div *ngIf="isEmail">
            <label app-sts-cms-txt key="sts-pick-login-email" for="sts_pick_email">
              Personal email address:
            </label>
            <input type="text"
                   name="sts_pick_email"
                   id="sts_pick_email"
                   formControlName="email"
                   maxlength="100"
                   [ngClass]="{'has-errors' : !emailIsValid}"
                   class="sts-textbox" >

            <div class="text-danger sts-form-row" *ngIf="frm.controls['email'].invalid && (frm.controls['email'].dirty || frm.controls['email'].touched)">
              <div app-sts-cms-txt key="sts-email-is-unique-required" *ngIf="frm.controls['email'].errors['emailRequired']">An email is required</div>
              <div app-sts-cms-txt key="sts-email-is-valid-required" *ngIf="frm.controls['email'].errors['validateEmail']">A valid email is required</div>
            </div>

          </div>

        </div>
        <!-- -->


      </div>
    </div>

    <div class="row sts-form-last-row sts-form-row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">
          <button app-sts-cms-txt key="sts-cancel-button"
                  class="sts-btn other-sts-btn"
                  type="button"
                  (click)="gotoHome()">
            Cancel
          </button>
          <app-sts-button [submit]="submitter"
                          [disabled]="formSubmitSuccess"
                          [ngClass]="{'disabled': formSubmitSuccess}"
                          key="sts-next-button">
            Next
          </app-sts-button>
        </div>
        <!-- -->

      </div>
    </div>

  </form>


</section>


